// @flow
import type { Condition } from './Condition'

const andCondition: Condition = {
  display: 'And',
  value: 'and'
}

const orCondition: Condition = {
  display: 'Or',
  value: 'or'
}

export {
  andCondition,
  orCondition
}



// WEBPACK FOOTER //
// ./src/lib/utils/conditions.js